<template>
    <section class="hero is-medium hero--splash" id="main">
        <div class="hero-body has-padding-bottom-1x-mobile">
            <div class="container">
                <div class="columns is-centered is-vcentered">
                    <div
                        class="column has-text-centered has-padding-top-2x-mobile has-background-white is-z-2 has-position-relative">
                        <div class="columns is-centered is-mobile">
                            <div class="column" style="max-width: 600px">
                                <h1 class="uptin-text-center" style="color: white !important;">
                                    {{ $t('common:hud.share_title') }}
                                </h1>
                                <vue-typed-js
                                    :key="locale"
                                    :strings="helloSubjects"
                                    :loop="true"
                                    :typeSpeed="9"
                                    :backSpeed="9"
                                    :backDelay="2000"
                                >
                                    <h1 class="is-size-3-mobile is-size-2 has-text-weight-bold typing-text" style="font-family: IRANSans;"
                                        v-html="$t('home:splash_hero.hello_world')">
                                    </h1>
                                </vue-typed-js>
                                <p class="is-size-4 padding-top-1x"
                                   v-html="$t('home:splash_hero.we_are_ob')">
                                </p>

                                <div class="has-padding-2x">
                                    <router-link :to="'get-app'" class="button uptin-splash-button is-background-dark1" active-class="is-active is-active--advertiser">
                                        {{ $t('home:download-app.more_details') }}
                                    </router-link>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="column splash-browser has-position-relative">
                        <figure class="has-position-absolute animated fadeInDown is-z-2 front-mockup" v-if="!isMobile()">
                            <img :src="whiteMockupImage">
                        </figure>
                        <figure class="has-position-absolute animated fadeInDown is-z-2 front-mockup mobile-screen" v-else>
                            <img :src="whiteMockupImage">
                        </figure>
                        <figure class="has-position-relative animated fadeInLeft is-z-1 back-mockup" v-if="!isMobile()">
                            <img :src="blackMockupImage">
                        </figure>
                        <figure class="has-position-relative animated fadeInLeft is-z-1 back-mockup mobile-screen" v-else>
                            <img :src="blackMockupImage">
                        </figure>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>


<style lang="scss">

.typed-element {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    justify-content: center;
}

.hero--splash {
    position: relative;
}

.splash-text {
    margin-top: 1rem;
}

.splash-browser {
    margin-top: 1rem;
    @media(max-width: 770px) {
        max-height: 45vh;
    }
}

.typewriter-cursor {
    font-weight: 400;
    color: #333;
}

.front-mockup {
    width: 125%;
    top: -15%;
    left: 8%;

    &.mobile-screen {
        top: -18%;
    }
}

.back-mockup {
    left: -20%;
}

</style>


<script>
import blackMockupImage from './assets/handset-ptt.webp';
import whiteMockupImage from './assets/smartphone-ptt.webp';

export default {
    name: 'splash-hero',
    data() {
        return {
            blackMockupImage,
            whiteMockupImage
        };
    },
    methods: {
        isMobile() {
            return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
        }
    },
    computed: {
        isI18nLoaded() {
            return this.$store.getters.isI18nLoaded;
        },
        helloSubjects() {
            return this.isI18nLoaded && [
                this.$i18n.t('home:splash_hero.location'),
                this.$i18n.t('home:splash_hero.economic'),
                this.$i18n.t('home:splash_hero.payment')
            ].map(subject => `${subject}`);
        },
        locale() {
            return this.$store.state.i18n;
        }
    }
}
</script>
